function FormSelect({
  id,
  name,
  label,
  value,
  onChange,
  options,
  placeholder = "Select an option",
  error,
  required = false,
  ...restProps
}) {
  const normalizedOptions = options.map((option) =>
    typeof option === "object" && option !== null
      ? {
          value: String(option.value ?? ""),
          label: String(option.label ?? option.value ?? ""),
        }
      : {
          value: String(option),
          label: String(option),
        }
  );

  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? `${id}-error` : undefined}
        {...restProps}
      >
        <option value="">{placeholder}</option>
        {normalizedOptions.map((option) => (
          <option key={`${option.value}-${option.label}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p id={`${id}-error`} className="field-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

export default FormSelect;
